export default "__VITE_ASSET__D9JmwTEf__"